import { useState, useEffect } from "react";

const navItems = [
  { label: "Home", target: "home" },
  { label: "About", target: "about" },
  { label: "Products", target: "products" },
  { label: "Features", target: "features" },
  { label: "Contact", target: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("home");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      const sections = navItems.map((item) => document.getElementById(item.target));
      let current = "home";
      sections.forEach((section) => {
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100) current = section.id;
        }
      });
      setActive(current);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white border-b border-gray-100" : "bg-transparent"
      }`}
      style={{ height: 80 }}
    >
      <div className="max-w-7xl mx-auto px-10 h-full flex items-center justify-between">
        {/* Logo */}
        <button onClick={() => scrollTo("home")} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/4d56948f-f323-4cfa-8fd6-32510aea7808.png"
            alt="ROXTVEL d.o.o. Pirot logo"
            className="h-10 w-auto object-contain"
          />
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-9">
          {navItems.map((item) => (
            <button
              key={item.target}
              onClick={() => scrollTo(item.target)}
              className={`text-sm whitespace-nowrap cursor-pointer transition-all duration-200 tracking-wide ${
                active === item.target
                  ? "text-[#1A1A1A] font-semibold"
                  : scrolled
                  ? "text-gray-500 hover:text-[#1A1A1A]"
                  : "text-white/80 hover:text-white font-medium"
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Mobile menu toggle */}
        <button
          className={`md:hidden cursor-pointer text-xl w-8 h-8 flex items-center justify-center ${
            scrolled ? "text-[#1A1A1A]" : "text-white"
          }`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"} />
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-10 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item.target}
              onClick={() => scrollTo(item.target)}
              className={`text-sm text-left whitespace-nowrap cursor-pointer ${
                active === item.target ? "text-[#1A1A1A] font-semibold" : "text-gray-500"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
